import script from "./SguParameterization.vue?vue&type=script&setup=true&lang=js"
export * from "./SguParameterization.vue?vue&type=script&setup=true&lang=js"

import "./SguParameterization.vue?vue&type=style&index=0&id=0403337b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0403337b"]])

export default __exports__